<div class="w-100">
  <mat-form-field class="mb-3">
    <mat-label>{{ labelName }}</mat-label>
    <input
      type="text"
      matInput
      [formControl]="control"
      [placeholder]="placeHolder"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete #auto="matAutocomplete">
      <!-- <mat-option *ngIf="(isLoading$ | async) ?? false">
              Cargando...
            </mat-option> -->
      @for (option of filteredOptions | async; track option['id']) {
      <mat-option [value]="option">
        {{ option[field] }}
      </mat-option>
      }
    </mat-autocomplete>
    @if (control.hasError('required')) {
    <mat-error> El campo es requerido </mat-error>
    } @if (!control.hasError('required')) {
    <mat-error> Debe seleccionar un elemento </mat-error>
    }
  </mat-form-field>
</div>
